






































































import { Component, Vue } from 'vue-property-decorator';
import { Application, Point } from 'pixi.js';
import * as PIXI from 'pixi.js';
import { DateTime } from 'luxon';
import { PixiChChart } from '@/lib/pixiChChart';
import { getLatestData, getLatestInfo } from '../api/data';
import { Int8Reader } from '../lib/heartRate';
import { LatestDataType } from '../../../common/dist/common';

@Component
export default class Measure extends Vue {
  private chRaw: PixiChChart[] = [];
  private chComputed: PixiChChart[] = [];
  private id = 0;
  private index = 0;
  private info: LatestDataType | null = null;
  private timer = 0;
  private currentTime = 0;
  private isRunning = false;

  private app = new Application({
    width: 1000,
    height: 600,
    antialias: false,
    transparent: true,
    resolution: window.devicePixelRatio,
  });

  destroyed() {
    this.app.destroy(true, {
      children: true,
      texture: true,
      baseTexture: true,
    });

    clearInterval(this.timer);
  }

  public mounted() {
    this.init();

    this.timer = setInterval(this.load, 15000);
  }

  private async init() {
    this.app.view.style.width = '1000px';
    const top = this.$refs.top as HTMLDivElement;
    top.appendChild(this.app.view);

    const rawHeight = 40;
    const rawWidth = 400;
    const computedHeight = 50;
    const computdWidth = 400;

    PIXI.settings.RESOLUTION = window.devicePixelRatio;
    PIXI.settings.TARGET_FPMS = 0.0005;

    this.chRaw = Array.from({ length: 14 }).map(
      (v, i) => new PixiChChart(rawWidth, rawHeight, 0, `${i + 1}Ch`),
    );
    this.chRaw.forEach((v, i) => {
      v.getC().position = new Point(0, rawHeight * i + 2);
    });
    this.app.stage.addChild(...this.chRaw.map((v) => v.getC()));

    this.chComputed = Array.from({ length: 11 }).map(
      (v, i) => new PixiChChart(computdWidth, computedHeight, 0, `${i + 15}Ch`),
    );
    this.chComputed.forEach((v, i) => {
      v.getC().position = new Point(rawWidth + 50, computedHeight * i + 2);
    });
    this.app.stage.addChild(...this.chComputed.map((v) => v.getC()));

    this.app.ticker.add(this.tick);

    this.load();
  }

  private tick() {
    if (this.currentTime > 15) {
      this.app.stop();
      this.isRunning = false;
      this.load();
      return;
    }
    this.currentTime += this.app.ticker.deltaMS / 1000;
    this.chRaw.forEach((v) => v.tick(this.currentTime, 15));
    this.chComputed.forEach((v) => v.tick(this.currentTime, 15));
  }

  private async load() {
    if (this.isRunning) {
      return;
    }
    const ret = await getLatestInfo();
    if (!ret.success) {
      return;
    }
    const isChange = this.id !== ret.data.id;
    if (!isChange) {
      return;
    }
    this.id = ret.data.id;
    this.info = ret.data;

    try {
      this.app.stop();
      this.isRunning = false;
      this.currentTime = 0;
      const blob = await getLatestData(this.id);
      const view = new DataView(await blob.arrayBuffer());
      this.chRaw.forEach((v, i) => {
        const reader = new Int8Reader(
          view,
          i * 1000,
          1000,
          1000 * 24,
          1000 * 15 * 25,
        );
        v.draw(reader, 400, Math.floor((1000 * 15) / 400), -128, 127);
        v.tick(0, 15);
      });
      this.chComputed.forEach((v, i) => {
        const reader = new Int8Reader(
          view,
          i * 1000 + 14 * 1000,
          1000,
          1000 * 24,
          1000 * 15 * 25,
        );
        v.draw(reader, 400, Math.floor((1000 * 15) / 400), -128, 127);
        v.tick(0, 15);
      });
      this.isRunning = true;
      this.app.start();
    } catch (err) {
      console.log(err);
    }
  }

  public getDate() {
    if (!this.info || !this.info.measureData.date) {
      return '';
    }
    return DateTime.fromISO(this.info.measureData.date).toFormat(
      'yyyy/LL/dd HH:mm:ss',
    );
  }

  public getExpectionDate() {
    if (!this.info || !this.info.measureData.patient?.expectingDate) {
      return '';
    }
    return DateTime.fromISO(
      this.info.measureData.patient.expectingDate,
    ).toFormat('yyyy/LL/dd');
  }

  public getWeekDays() {
    if (
      !this.info ||
      !this.info.measureData.patient?.expectingDate ||
      !this.info.measureData.date
    ) {
      return '';
    }
    const begin = DateTime.fromISO(this.info.measureData.patient.begin);
    const measuerDate = DateTime.fromISO(this.info.measureData.date);
    const diff = measuerDate.diff(begin, 'days').shiftTo('weeks', 'days');
    return `${Math.floor(diff.weeks)} / ${Math.floor(diff.days)}`;
  }

  public getComment() {
    return this.info?.measureData.comment || '';
  }

  public getTime() {
    if (!this.info) {
      return '';
    }

    const date = DateTime.local(0, 1, 1, 0, 0, 0);
    return `${date
      .plus({ second: this.info.index * 15 + this.currentTime })
      .toFormat('mm:ss')} / ${date
      .plus({ second: (this.info.index + 1) * 15 })
      .toFormat('mm:ss')}`;
  }
}
